import { motion } from 'framer-motion';

export default function HeroAnimation() {
  return (
    <div className="relative w-full h-64 md:h-80">
      <svg viewBox="0 0 400 200" className="w-full h-full">
        {/* Background glow */}
        <defs>
          <radialGradient id="heroGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.2" />
            <stop offset="100%" stopColor="#3b82f6" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx="200" cy="100" r="120" fill="url(#heroGlow)" />

        {/* Main auction item - floating isometric cube */}
        <motion.g
          animate={{ 
            y: [0, -8, 0],
          }}
          transition={{ 
            duration: 3, 
            repeat: Infinity, 
            ease: 'easeInOut' 
          }}
        >
          {/* Isometric prize box */}
          <polygon
            points="200,50 270,90 200,130 130,90"
            fill="#fbbf24"
            stroke="#f59e0b"
            strokeWidth="2"
          />
          <polygon
            points="200,130 270,90 270,140 200,180"
            fill="#f59e0b"
            stroke="#d97706"
            strokeWidth="2"
          />
          <polygon
            points="200,130 130,90 130,140 200,180"
            fill="#d97706"
            stroke="#b45309"
            strokeWidth="2"
          />
          {/* Star decoration */}
          <motion.text
            x="200"
            y="100"
            textAnchor="middle"
            fontSize="30"
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            style={{ originX: '200px', originY: '100px' }}
          >
            🏆
          </motion.text>
        </motion.g>

        {/* Orbiting bids */}
        {[0, 1, 2].map((i) => {
          const angle = (i * 120) * (Math.PI / 180);
          const radius = 85;
          return (
            <motion.g
              key={i}
              animate={{
                rotate: 360,
              }}
              transition={{
                duration: 8,
                repeat: Infinity,
                ease: 'linear',
                delay: i * 0.5,
              }}
              style={{ originX: '200px', originY: '100px' }}
            >
              <motion.g
                animate={{ 
                  scale: [1, 1.1, 1],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  delay: i * 0.3,
                }}
              >
                <rect
                  x={200 + Math.cos(angle) * radius - 20}
                  y={100 + Math.sin(angle) * radius - 12}
                  width="40"
                  height="24"
                  rx="4"
                  fill={['#10b981', '#8b5cf6', '#f43f5e'][i]}
                />
                <text
                  x={200 + Math.cos(angle) * radius}
                  y={100 + Math.sin(angle) * radius + 4}
                  textAnchor="middle"
                  fontSize="10"
                  fill="white"
                  fontWeight="bold"
                >
                  {['£100', '£150', '£200'][i]}
                </text>
              </motion.g>
            </motion.g>
          );
        })}

        {/* Sparkles */}
        {[
          { x: 120, y: 50, delay: 0 },
          { x: 280, y: 60, delay: 0.5 },
          { x: 100, y: 150, delay: 1 },
          { x: 300, y: 140, delay: 1.5 },
        ].map((spark, i) => (
          <motion.text
            key={i}
            x={spark.x}
            y={spark.y}
            fontSize="14"
            animate={{
              opacity: [0, 1, 0],
              scale: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: spark.delay,
            }}
          >
            ✨
          </motion.text>
        ))}
      </svg>
    </div>
  );
}
